import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { InteractiveListBaseItem } from './InteractiveListBaseItem.js';
import { jsx } from '@emotion/react';
import { Box } from '../Box/Box.js';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '@indeed/ifl-icons';
import '../Text/Text.js';
import '../../utils/createResponsive.js';
import '../Flex/Flex.js';

const INTERACTIVE_LIST_ACTION_DEFAULT_TAG = "button";
const InteractiveListAction = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    as = INTERACTIVE_LIST_ACTION_DEFAULT_TAG,
    children,
    contentAfter,
    contentBefore,
    destructive = false,
    supportiveContent,
    ...remainingProps
  } = props;
  return jsx(Box, {
    as: "li",
    sx: {
      margin: 0,
      padding: 0,
      textIndent: 0,
      listStyleType: "none"
    }
  }, jsx(InteractiveListBaseItem, _extends({
    as: as,
    ref: ref,
    type: "button",
    contentAfter: contentAfter,
    contentBefore: contentBefore,
    supportiveContent: supportiveContent,
    destructive: destructive
  }, remainingProps), children));
});
InteractiveListAction.displayName = "InteractiveListAction";

export { InteractiveListAction };
